module.exports = __webpack_public_path__ + "static/media/sample.4b41a347.pdf";